import { useFormikWrapper } from "../../../components/formik_wrapper";
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import * as rand_pass from "secure-random-password";

import * as actions from "../../../actions";

import {
  regions,
  module_plans as plans,
  CompanyStatus,
} from "../../../util/master-data";

import SaveIcon from "../../../assets/images/floppy-disk.svg";
import SuccesGIF from "../../../assets/images/icon_success_check.gif";

import { toast } from "react-toastify";

import { FlatButton } from "../../../components/buttons";
import { CustomerDetails } from "./components/customer_details_template";
import { AdminDetailsTemplate } from "./components/admin_account_details_template";
import { ModuleDetails } from "../components/module_details";

import validationSchema from "./util/validation-schema";
import { useNavigate } from "react-router-dom";
import { Modal } from "flowbite-react";
import { CREATECOMPANY_RESPONSE } from "../../../constants/action_types";

export default function CreateCustomer() {
  const createResponse = useSelector((state) => state.company.update_response);

  const dispatch = useDispatch();

  const navigate = useNavigate();

  const [activeTitle, setActiveTitle] = useState();

  const [visited, setVisited] = useState({});

  const _modules = useSelector((state) => state.company.modules);
  const _allModules = useSelector((state) => state.company.allModules);

  const [selectedModules, setModules] = useState([...plans[0].modules]);

  const [modalState, setModalState] = useState();

  const randomPassword = useMemo(() => {
    return rand_pass.randomPassword({
      length: 12,
      characters: [
        rand_pass.lower,
        rand_pass.symbols,
        rand_pass.upper,
        rand_pass.symbols,
        rand_pass.digits,
      ],
    });
  }, []);


  useEffect(() => {
    dispatch(actions.GETALLMODULES_RESPONSE({}));
  }, [dispatch]);

  // 2. Derive allModules from _allModules
  const allModules = useMemo(() => {
    if (!_allModules) return {};
    return _allModules.reduce((acc, module) => {
      acc[module.module_key] = module.module_uid;
      return acc;
    }, {});
  }, [_allModules]);


  useEffect(() => {
    if (Object.keys(allModules).length === 0) {
      setModules([...plans[0].modules]);
    } else {
      const _module_uids = _modules?.data?.map((m) => allModules[m.module.module_key] || null) || [];
      if (_module_uids.length > 0) setModules([..._module_uids]);
      else setModules([...plans[0].modules]);
    }
  }, [_modules?.data]);

  useEffect(() => {
    if (createResponse.type === CREATECOMPANY_RESPONSE) {
      // navigate("/customers");
      setModalState("pop-up");
    }
  }, [createResponse]);

  useEffect(() => {
    setVisited(
      steppers.reduce((_visited, _step, _index) => {
        return {
          ..._visited,
          [_step.title]: _index === 0,
        };
      }, visited)
    );
    setActiveTitle(steppers[0].title);
  }, []);

  useEffect(() => {
    if (activeTitle && !visited[activeTitle])
      setVisited({ ...visited, [activeTitle]: true });
  }, [activeTitle]);

  const customerDetailsForm = useFormikWrapper({
    initialValues: {
      company_name: "",
      company_phone: "",
      company_login_name: "",
      company_logo: "",
      company_address: "",
      company_country: "",
      company_currency: "",
      company_timezone: "",
      region: (regions.find((r) => r.code === "apac-staging") || regions[0]).code,
      company_email: "",
      company_industry: "",
      company_verticals: "",
      company_status: CompanyStatus[0],
      isDataMigrationEnabled: false,
      from_company_ref_date: "",
      cloneAccount: "None",
      migrationType: "Config",
      regionObjectList: [],
      trial_period: null,
    },
    isInitialValid: false,
    validationSchema: validationSchema.customerDetailsSchema,
    onSubmit: () => { },
  });

  const adminDetailsForm = useFormikWrapper({
    initialValues: {
      emp_code: "",
      first_name: "",
      last_name: "",
      email: "",
      password: randomPassword,
      designation: "",
      home_phone_number: "",
      work_phone_number: "",
      profile_picture: "",
      notifyCustomer: false,
    },
    isInitialValid: false,
    validationSchema: validationSchema.adminDetailsSchema,
    onSubmit: () => { },
  });

  const steppers = [
    {
      title: "Company Details",
      template: (
        <CustomerDetails
          readOnly={activeTitle === "Preview & Save"}
          formik={customerDetailsForm}
        />
      ),
      form: customerDetailsForm,
    },
    {
      title: "Admin Account Details",
      template: (
        <AdminDetailsTemplate
          readOnly={activeTitle === "Preview & Save"}
          formik={adminDetailsForm}
        />
      ),
      form: adminDetailsForm,
    },
    {
      title: "Company Modules",
      template: (
        <ModuleDetails
          readOnly={activeTitle === "Preview & Save"}
          modules={selectedModules}
          onChange={setModules}
        />
      ),
    },
    {
      title: "Preview & Save",
    },
  ];

  const handleStepClick = (step) => {
    let [currentStep] = steppers?.filter((s) => s.title === activeTitle);
    currentStep?.form?.setTouched(
      Object.keys(currentStep.form.values).reduce(
        (touched, field) => ({ ...touched, [field]: true }),
        {}
      )
    );
    const currentStepIndex = steppers?.findIndex(
      (s) => s.title === activeTitle
    );
    const clickedStepIndex = steppers.findIndex((s) => s.title === step.title);
    const isClickedStepBeforeCurrentStep = clickedStepIndex < currentStepIndex;
    if (
      (currentStep?.form ? currentStep?.form?.isValid : true) ||
      isClickedStepBeforeCurrentStep
    ) {
      setActiveTitle(step.title);
    }

    if (
      currentStep?.title === "Company Details" &&
      currentStep?.form?.isValid &&
      currentStep?.form?.values?.from_company_uid
    ) {
      const company_uid = currentStep.form.values.from_company_uid;
      const region_code = currentStep.form.values.from_company_region;
      dispatch(actions.GETMODULES_REQ({ company_uid, region_code }));
    }
  };

  const handleSubmit = () => {
    if (steppers.every((_stepper) => visited[_stepper.title])) {
      const payload = {
        company: customerDetailsForm.values,
        user: adminDetailsForm.values,
        module: {
          modules: selectedModules,
          setModules: selectedModules.length > 0,
        },
      };
      dispatch(actions.CREATECOMPANY_REQ(payload));
    } else {
      for (let _step in visited) {
        if (!visited[_step]) {
          toast.warning(`Kindly provide necessary info in ${_step}`);
          setActiveTitle(_step);
          break;
        }
      }
    }
  };

  const closeModal = () => {
    dispatch(actions.RESET_STATE("company.new_company"));
    navigate("/customers");
    setModalState(undefined);
  };

  return (
    <main className="-mt-24 min-h-[75vh]">
      <div className="mx-auto max-w-[86rem] py-3 sm:px-6 lg:px-8">
        <div className="flex flex-1 space-x-4">
          <aside className="w-80 rounded-lg shadow self-start sticky top-4">
            <div className="p-6 rounded-lg bg-white">
              <nav aria-label="Progress">
                <ol className="overflow-hidden">
                  {steppers.map((_stepper, index) => (
                    <li
                      key={`li-${_stepper.title}`}
                      className="relative cursor-pointer pb-10"
                      onClick={() => {
                        handleStepClick(_stepper);
                      }}
                    >
                      {index + 1 !== steppers.length && (
                        // <div
                        //   className="absolute left-4 top-4 -ml-px mt-0.5 h-full w-0.5 "
                        //   aria-hidden="true"
                        // ></div>
                        <div
                          class={`${_stepper.form
                            ? _stepper.form.isValid
                              ? "bg-green-600"
                              : "bg-gray-600/25"
                            : visited[_stepper.title]
                              ? "bg-green-600"
                              : "bg-gray-600/25"
                            } absolute left-4 top-4 -ml-px mt-0.5 h-full w-0.5`}
                          aria-hidden="true"
                        ></div>
                      )}
                      <span className="group relative flex items-start">
                        <span className="flex h-9 items-center">
                          {/* Completed */}
                          {(_stepper.form
                            ? _stepper.form.isValid
                            : visited[_stepper.title]) &&
                            _stepper.title !== activeTitle && (
                              <span className="relative z-10 flex h-8 w-8 items-center justify-center rounded-full bg-green-600 group-hover:bg-green-800">
                                <svg
                                  className="h-5 w-5 text-white"
                                  viewBox="0 0 20 20"
                                  fill="currentColor"
                                  aria-hidden="true"
                                >
                                  <path
                                    fill-rule="evenodd"
                                    d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z"
                                    clip-rule="evenodd"
                                  ></path>
                                </svg>
                              </span>
                            )}
                          {/* Unvisited step / up-coming step */}
                          {(_stepper.form
                            ? !_stepper.form.isValid
                            : !visited[_stepper.title]) &&
                            activeTitle !== _stepper.title && (
                              <span className="relative z-10 flex h-8 w-8 items-center justify-center rounded-full border-2 border-gray-300 bg-white group-hover:border-gray-400">
                                <span className="h-2.5 w-2.5 rounded-full bg-transparent group-hover:bg-gray-300"></span>
                              </span>
                            )}
                          {/* Current step */}
                          {_stepper.title === activeTitle && (
                            <span className="relative z-10 flex h-8 w-8 items-center justify-center rounded-full border-2 border-green-600 bg-white">
                              <span className="h-2.5 w-2.5 rounded-full bg-green-600"></span>
                            </span>
                          )}
                        </span>

                        <span className="ml-4 flex min-w-0 flex-col">
                          <span className="text-sm font-medium">
                            {_stepper.title}
                          </span>
                          <span className="text-sm text-gray-500">
                            {_stepper.description}
                          </span>
                        </span>
                      </span>
                    </li>
                  ))}
                </ol>
              </nav>
            </div>
          </aside>

          <section
            aria-labelledby="primary-heading"
            className="flex h-full min-w-0 flex-1 flex-col lg:order-last"
          >
            <div className="h-full">
              <div className="relative h-full w-full bg-white rounded-lg shadow px-4">
                <div className="p-2">
                  <div className="flow-root">
                    <div className="-mx-4 -my-2 sm:-mx-6 lg:-mx-8">
                      <div className="blockmin-w-full py-4 align-middle sm:px-6 lg:px-8">
                        {steppers.map((_stepper, index) => (
                          <div
                            key={`header-${_stepper.title}`}
                            className={`${_stepper.title === activeTitle ? "" : "hidden"
                              }`}
                          >
                            <div className="mx-auto pb-3 border-b sm:flex sm:items-center sm:justify-between">
                              <h3 className="text-lg font-semibold leading-6 text-gray-900">
                                {activeTitle}
                              </h3>
                              <div className="mt-3 sm:ml-4 sm:mt-0">
                                <div className="flex space-x-2">
                                  {index + 1 !== steppers.length ? (
                                    <div className="relative">
                                      <div
                                        className="absolute inset-0 z-10 cursor-pointer"
                                        onClick={() => {
                                          handleStepClick(steppers[index + 1]);
                                        }}
                                      ></div>
                                      <FlatButton
                                        disabled={
                                          _stepper.form
                                            ? !_stepper.form.isValid
                                            : false
                                        }
                                        className=" inline-flex items-center gap-x-1.5"
                                      >
                                        Proceed
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          fill="none"
                                          viewBox="0 0 24 24"
                                          strokeWidth="1.5"
                                          stroke="currentColor"
                                          className="w-4 h-4"
                                        >
                                          <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3"
                                          ></path>
                                        </svg>
                                      </FlatButton>
                                    </div>
                                  ) : (
                                    <FlatButton
                                      onClick={handleSubmit}
                                      type="FlatButton"
                                      className={`${_stepper.form
                                        ? _stepper.form.isValid
                                          ? "bg-gray-600 hover:bg-gray-400"
                                          : "bg-gray-400 hover:bg-gray-400"
                                        : "bg-gray-600 hover:bg-gray-400"
                                        } relative inline-flex items-center gap-x-1.5 rounded-md  px-4 py-2 text-sm font-semibold text-white shadow-sm  focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600`}
                                    >
                                      Save
                                      <img
                                        src={SaveIcon}
                                        alt="save"
                                        className="w-4 h-4"
                                      />
                                    </FlatButton>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                        {steppers.map(
                          (_stepper) =>
                            _stepper.template && (
                              <>
                                <div
                                  key={`divider-${_stepper.title}`}
                                  className={`${activeTitle === "Preview & Save"
                                    ? ""
                                    : "hidden"
                                    } container mx-auto mt-4 `}
                                >
                                  <div className="flex items-center">
                                    <div className="w-1/14 border-b border-gray-400"></div>
                                    <div className="mr-4 text-md text-gray-700">
                                      {_stepper.title}
                                    </div>
                                    <div className="flex-grow border-b border-gray-400"></div>
                                  </div>
                                </div>
                                <div
                                  key={`template-${_stepper.title}`}
                                  className={`${_stepper.title === activeTitle ||
                                    activeTitle === "Preview & Save"
                                    ? ""
                                    : "hidden"
                                    } relative`}
                                >
                                  {_stepper.template}
                                </div>
                              </>
                            )
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <Modal
        show={modalState === "pop-up"}
        size="xl"
        popup
        onClose={() => closeModal()}
      >
        <Modal.Header>
          <h2 className="mb-5 p-2 text-lg font-bold text-gray-600 dark:text-gray-600">
            Company Creation Successful
          </h2>
        </Modal.Header>
        <Modal.Body>
          <div>
            <div className="flex flex-row items-center gap-x-5 justify-center">
              {" "}
              <img
                src={SuccesGIF}
                alt=""
                className="h-[120px] w-[230px] rounded-full object-cover"
              />
              {/* <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.0}
                  stroke="currentColor"
                  className="mx-auto mb-4 h-[120px] w-[120px] mr-4 text-green-500 dark:text-gray-200"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg> */}
              <div>
                <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-500">
                  Company account has been created successfully. Please find the
                  details below,
                </h3>
                <div className="[&>p>b]:mr-2 [&_p]:mb-4 [&>p>b]:text-gray-600 font-bold text-blue-500">
                  <p>
                    <b>Company Name:</b>{" "}
                    {createResponse?.payload?.data?.company_login_name}
                  </p>
                  <p>
                    <b>Email:</b>
                    {createResponse?.payload?.data?.email}
                  </p>
                  <p>
                    <b>Password:</b>
                    {createResponse?.payload?.data?.password}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </main>
  );
}
